import { Can as CaslCan, useAbility, type CanProps } from '@casl/react';

import type { AnyAbility } from '@casl/ability';

/**
 * Contextual Can component
 */
export function Can<T extends AnyAbility>(props: CanProps<T>) {
  const ability = useAbility<T>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <CaslCan ability={ability} {...(props as any)} />;
}
